class ImageBanner extends HTMLElement {
  constructor() {
    super();
    this.banner = this.querySelector('.image-banner');
    this.swiperElement = this.querySelector('swiper-slider');
    
    if (this.swiperElement) {
      this.init();
    }
  }

  init() {
    // Attendre que le swiper soit initialisé
    const checkSwiper = setInterval(() => {
      if (this.swiperElement.swiper) {
        clearInterval(checkSwiper);
        this.swiper = this.swiperElement.swiper;
        this.setupClickable();
        this.setupSlideChange();
        this.setupCustomProgressbar();
      }
    }, 100);

    // Toujours attacher les handlers de clic directement sur les slides du DOM
    // Cela fonctionne même avec une seule slide
    setTimeout(() => {
      const allSlides = this.querySelectorAll('.image-banner__slide');
      allSlides.forEach((slide) => {
        this.attachClickHandler(slide);
      });
    }, 200);
  }

  setupCustomProgressbar() {
    // Fonction pour mettre à jour la progressbar avec une barre fixe de 40px qui glisse
    const updateProgressbar = () => {
      const progressbarFill = this.querySelector('.swiper-pagination-progressbar-fill');
      if (!progressbarFill) return;

      const totalSlides = this.swiper.slides.length;
      const activeIndex = this.swiper.activeIndex;
      
      // La barre totale fait 80px (8rem)
      // La barre de progression fait 53.33px de large et glisse
      const totalWidth = 80;
      const fillWidth = 53.33;
      const maxTranslate = totalWidth - fillWidth;
      
      // Calculer la position de translation (de 0 à maxTranslate)
      const translateX = totalSlides > 1 ? (maxTranslate * activeIndex) / (totalSlides - 1) : 0;
      
      progressbarFill.style.transform = `translate3d(${translateX}px, 0px, 0px) scaleX(1) scaleY(1)`;
      progressbarFill.style.width = `${(fillWidth / totalWidth) * 100}%`;
    };

    // Mettre à jour au chargement
    updateProgressbar();

    // Mettre à jour à chaque changement de slide
    this.swiper.on('slideChange', updateProgressbar);
    this.swiper.on('progress', updateProgressbar);
  }

  setupClickable() {
    // Cette fonction est conservée pour la compatibilité mais le vrai attachement
    // se fait maintenant dans init() directement sur le DOM
  }

  attachClickHandler(slide) {
    // Vérifier si le handler n'a pas déjà été attaché
    if (slide.dataset.clickHandlerAttached) {
      return;
    }
    slide.dataset.clickHandlerAttached = 'true';
    
    const link = slide.dataset.slideLink;
    slide.style.cursor = link && link !== '' ? 'pointer' : 'default';
    
    slide.addEventListener('click', (e) => {
      // Ne pas déclencher le clic si on clique sur un bouton, lien ou contrôle swiper
      if (
        e.target.closest('.button') ||
        e.target.closest('a') ||
        e.target.closest('.swiper-button-prev') ||
        e.target.closest('.swiper-button-next') ||
        e.target.closest('.swiper-pagination')
      ) {
        return;
      }

      const slideLink = slide.dataset.slideLink;

      if (slideLink && slideLink !== '') {
        window.location.href = slideLink;
      }
    });
  }

  setupSlideChange() {
    if (this.swiper && this.swiper.on) {
      this.swiper.on('slideChange', () => {
        // Le curseur est déjà géré dans attachClickHandler
      });
    }
  }

  updateCursor() {
    // Cette fonction n'est plus nécessaire car le curseur est géré dans attachClickHandler
  }
}

customElements.define('image-banner-section', ImageBanner);
